import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatBotApi {
  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  private chatBotApi = 'chat';

  constructor(private http: HttpClient) { }

  chatApi(params): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}${this.chatBotApi}`, params);
  }
}